"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Close = function Close(_ref) {
  var className = _ref.className,
      width = _ref.width,
      height = _ref.height,
      fill = _ref.fill,
      onClick = _ref.onClick;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 ".concat(width, " ").concat(height),
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.86035 1L1.10081 10.3355M1 1.09961L9.9641 10.2311",
    stroke: "#505050",
    strokeWidth: "2.22575"
  }));
};

Close.defaultProps = {
  width: 11,
  height: 12,
  fill: 'none'
};
Close.propTypes = {
  width: _propTypes.number,
  height: _propTypes.number,
  fill: _propTypes.string,
  className: _propTypes.string,
  onClick: _propTypes.func
};
var _default = Close;
exports.default = _default;